import React, { useCallback, useMemo } from "react";
import { useTranslation } from 'react-i18next';
import "../../css/index.css";
import "../../css/Pages.css";
import { useHistory, useParams } from "react-router-dom";
import AbonnementCollapsible from "./Components/AbonnementCollapsible";
import KlantDetailsSection from "./Components/KlantDetailsSection";
import useKlant from "./UseKlant";

const KlantPagina = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const history = useHistory();
    const { klant, loading, error } = useKlant(id);
    const abonnementen = useMemo(() => klant?.abonnementen || [], [klant]);

    const handleAddAbonnement = useCallback(() => {
        if (!klant) return;
        history.push({
            pathname: "/Abonnementtoevoegen",
            state: { klantObject: klant },
        });
    }, [history, klant]);

    const handleAddInterface = useCallback(() => {
        if (!klant) return;
        history.push({
            pathname: "/Interfacetoevoegen",
            state: { klantObject: klant },
        });
    }, [history, klant]);

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-text">{t('common.loadingData')}</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-alert">
                <h3>{t('common.error')}</h3>
                <p>{t('errors.generic')}</p>
            </div>
        );
    }

    if (!klant) {
        return (
            <div className="loading-container">
                <div className="loading-text">{t('common.noDataAvailable')}</div>
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <div className="page-header">
                <h2>{klant?.naam || t('customers.customerDetails')}</h2>
            </div>

            <div className="page-content">
                <div className="action-bar">
                    <div className="action-buttons">
                        <button className="btn btn-primary" onClick={handleAddAbonnement}>
                            {t('subscriptions.addSubscription')}
                        </button>
                        <button className="btn btn-secondary" onClick={handleAddInterface}>
                            {t('interface.addInterface')}
                        </button>
                    </div>
                </div>

                                <KlantDetailsSection klant={klant} />

        <div className="table-wrapper">
                    <div className="table-scroll" style={{ overflowX: "hidden" }}>
                        <table
                            className="table"
                            name="aboTable"
                            style={{ tableLayout: "fixed", width: "100%", wordBreak: "break-word" }}
                        >
                            <colgroup>
                                <col style={{ width: "24%" }} />
                                <col style={{ width: "9%" }} />
                                <col style={{ width: "9%" }} />
                                <col style={{ width: "9%" }} />
                                <col style={{ width: "7%" }} />
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "18%" }} />
                            </colgroup>
                            <thead>
                                <tr>
                                        <th>{t('subscriptions.title')}</th>
                                        <th>{t('subscriptions.startDate')}</th>
                                        <th>{t('subscriptions.endDate')}</th>
                                        <th>{t('subscriptions.status')}</th>
                                        <th>{t('interface.interfaces')}</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {abonnementen.length > 0 ? (
                                    abonnementen.map((abonnement, index) => (
                                        <AbonnementCollapsible
                                            key={`${abonnement.abonnementId || index}`}
                                            abonnement={abonnement}
                                            klant={klant}
                                            index={index}
                                        />
                                    ))
                                ) : (
                                    <tr className="empty-row">
                                            <td colSpan="8">{t('subscriptions.noSubscriptions')}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KlantPagina;